import { Vehicle } from '@otw/models/inventory'
import { fetchVinData } from 'core/inventory/fetchVinData'

export const addVinData = async (vehicle: Omit<Vehicle, 'id'>): Promise<Omit<Vehicle, 'id'>> => {
  const vinData = await fetchVinData(vehicle.vin)
  const relevantVariables = new Map<string, keyof Omit<Vehicle, 'id'>>([
    ['Model year', 'year'],
    ['Model', 'model'],
    ['Make', 'make'],
    ['Fuel Type - Primary', 'fuel'],
  ])

  const expandedVindata = Object.fromEntries(
    vinData
      .filter(vinDataItem => {
        const isRelevant = relevantVariables.has(vinDataItem.Variable)
        if (!isRelevant) return false

        const vehicleKey = relevantVariables.get(vinDataItem.Variable)
        if (!vehicleKey) return false

        const isNeeded = !vehicle[vehicleKey] || vehicle[vehicleKey] === ''
        return isNeeded
      })
      .map(vinDataItem => [relevantVariables.get(vinDataItem.Variable), vinDataItem.Value]),
  )

  return {
    ...vehicle,
    ...expandedVindata,
  }
}
